<template>
  <div class="password-tips">
    <span class="password-tips__title">{{ $t(`${namespace}.createStrongPassword`) }}</span>
    <ul class="password-tips__list">
      <li
        class="password-tips__list__item"
        :class="[
          { 'password-tips__list__item--success': typeof rules.charsCount === 'boolean' && rules.charsCount },
          { 'password-tips__list__item--error': typeof rules.charsCount === 'boolean' && !rules.charsCount }
        ]"
      >
        <v-icon v-if="rules.charsCount">check</v-icon>
        <v-icon v-else>cancel</v-icon>
        <span>{{ $t(`${namespace}.passwordTipCharsCount`) }}</span>
      </li>

      <li
        class="password-tips__list__item"
        :class="[
          { 'password-tips__list__item--success': typeof rules.lowerCase === 'boolean' && rules.lowerCase },
          { 'password-tips__list__item--error': typeof rules.lowerCase === 'boolean' && !rules.lowerCase }
        ]"
      >
        <v-icon v-if="rules.lowerCase">check</v-icon>
        <v-icon v-else>cancel</v-icon>
        <span>{{ $t(`${namespace}.passwordTipLowerCase`) }}</span>
      </li>

      <li
        class="password-tips__list__item"
        :class="[
          { 'password-tips__list__item--success': typeof rules.upperCase === 'boolean' && rules.upperCase },
          { 'password-tips__list__item--error': typeof rules.upperCase === 'boolean' && !rules.upperCase }
        ]"
      >
        <v-icon v-if="rules.upperCase">check</v-icon>
        <v-icon v-else>cancel</v-icon>
        <span>{{ $t(`${namespace}.passwordTipUpperCase`) }}</span>
      </li>

      <li
        class="password-tips__list__item"
        :class="[
          { 'password-tips__list__item--success': typeof rules.number === 'boolean' && rules.number },
          { 'password-tips__list__item--error': typeof rules.number === 'boolean' && !rules.number }
        ]"
      >
        <v-icon v-if="rules.number">check</v-icon>
        <v-icon v-else>cancel</v-icon>
        <span>{{ $t(`${namespace}.passwordTipNumber`) }}</span>
      </li>

      <li
        class="password-tips__list__item"
        :class="[
          { 'password-tips__list__item--success': typeof rules.specialChars === 'boolean' && rules.specialChars },
          { 'password-tips__list__item--error': typeof rules.specialChars === 'boolean' && !rules.specialChars }
        ]"
      >
        <v-icon v-if="rules.specialChars">check</v-icon>
        <v-icon v-else>cancel</v-icon>
        <span>{{ $t(`${namespace}.passwordTipSpecialChars`) }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'PasswordTips',
  props: {
    password: {
      type: String
    }
  },
  data () {
    return {
      namespace: 'Components.PasswordTips',
      rules: {
        charsCount: null,
        lowerCase: null,
        upperCase: null,
        number: null,
        specialChars: null
      }
    }
  },
  methods: {
    checkStrongPassword () {
      this.rules = {
        charsCount: this.password.length >= 8,
        lowerCase: /(?=.*[a-z])/.test(this.password),
        upperCase: /(?=.*[A-Z])/.test(this.password),
        number: /(?=.*[0-9])/.test(this.password),
        specialChars: /(?=.*[?!@#$%^&*()_\-+=`~[\]{}:;'<>/\\]+)/.test(this.password)
      }
    }
  },
  watch: {
    password () {
      this.checkStrongPassword()
    }
  }
}
</script>

<style lang="scss" scoped>
.password-tips {
  margin-bottom: 24px;
}

.password-tips__title {
  display: block;
  margin-bottom: 15px;
}

.password-tips__list {
  list-style-type: none;
  padding: 0;
}

.password-tips__list__item {
  padding-left: 24px;
  position: relative;

  .v-icon {
    color: $gray-4;
    font-size: 16px;
    left: 0;
    position: absolute;
    top: 3px;
  }
}

.password-tips__list__item--success {

  .v-icon {
    color: $success;
  }
}

.password-tips__list__item--error {
  color: $error;

  .v-icon {
    color: $error;
  }
}
</style>
